<template>
    <div>
        <div
            ref="dot"
            :class="statusDotClass"
            style="display: inline-block;"
        ></div>
        <ui-tooltip
            v-if="label"
           :trigger="$refs.dot"
        >{{ label }}</ui-tooltip>
    </div>
</template>

<style scoped>
    .status-dot { width: 10px; height: 10px; background: #ccc; border-radius: 50%; }
    .status-dot.status-dot-green { background: #12c457; }
    .status-dot.status-dot-red { background: #e84c85; }
    .status-dot.status-dot-orange { background: #FBB13C; }
</style>

<script>
    export default {
        computed: {
            label() {
                return '';
            },
            shouldShowRed() {
                return false
            },
            shouldShowOrange() {
                return false
            },
            shouldShowGreen() {
                return false
            },
            statusDotClass() {
                let classnames = 'status-dot';

                if (this.shouldShowRed) {
                    classnames += ' status-dot-red';
                } else if (this.shouldShowOrange) {
                    classnames += ' status-dot-orange';
                } else if (this.shouldShowGreen) {
                    classnames += ' status-dot-green';
                }

                return classnames;
            }
        }
    }
</script>